export type BaseVariantsNames = 'base';

export function useBaseVariant(): BaseVariantsNames {
  return 'base';
}
